import { useState, useEffect } from 'react';

import API from 'service/api';
import Util from 'service/util';
import PlanHistory from 'component/PlanHistory';

const SinglePriceModal = ({plan}) =>
{
  const [hist, setHistory] = useState(null);
  const [error, setError]  = useState('');

  const refreshData = () => {
    API.getServicePlanDetail(plan).then(data =>
    {
      setHistory(data);
      if (!data?.length) setError('無資料。');
    });
  }

  // init
  useEffect(refreshData, []);

  const P = plan;
  const H = hist;
  const n_com = Util.getCompanyName(P.company);
  const n_loc = `${P.loc_name_zh} ${P.loc_name_en}`.trim();
  const n_pln = P.cd_plan + String(P.vh_type);

  return (<>
    <strong>{n_com} 計劃{n_pln} - {n_loc}</strong>
    { !H?<div>正在讀取...</div>:(
        !H.length
        ?<div>讀取失敗。</div>
        :<PlanHistory {...P} history={H}
          onUpdate={refreshData} />
      )
    }
    <div className="error-msg">
      { error }
    </div>
  </>);

}

export default SinglePriceModal;
